import React, { useEffect, useState } from 'react';
import { useI18n } from '../../context/i18nContext';

const SavedIndicator = ({ status }) => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(status === 'saved' || status === 'error');

  useEffect(() => {
    if (status === 'saved' || status === 'error') {
      setVisible(true);
      const timer = setTimeout(() => {
        if (status === 'saved') setVisible(false);
      }, 2500);
      return () => clearTimeout(timer);
    } else if (status === null) {
      setVisible(false);
    }
  }, [status]);

  if (!visible) return null;

  if (status === 'saving') {
    return <div className="saved-indicator saved-indicator--saving">…</div>;
  }

  if (status === 'saved') {
    return (
      <div className="saved-indicator saved-indicator--saved">
        ✅ {t('admin.saved')}
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="saved-indicator saved-indicator--error">
        ⚠️ {t('admin.saveFailed')}
      </div>
    );
  }

  return null;
};

export default SavedIndicator;
